module.exports = __webpack_public_path__ + "fonts/iconfont.149a84f1.ttf";